/**
 * @module app.controls3dComponent
 */
import appBase from './index.js';
import {getConstrainedResolution} from "./utils.js";


/**
 * @param {angular.Scope} $scope Scope.
 * @constructor
 * @ngInject
 * @struct
 * @private
 */
class Controls3dController {
  constructor($scope) {
    /**
     * @type {angular.Scope}
     * @private
     */
    this.scope_ = $scope;

    /**
     * @type {app.OlcsControl}
     * @export
     */
    this.olcsControl;

    /**
     * @type {number}
     * @private
     */
    this.minTilt_;

    /**
     * @type {number}
     * @private
     */
    this.maxTilt_;
  }
  $onInit() {

    // wait for the olcsControl object to be available.
    this.scope_.$watch(
      () => this.olcsControl,
      (value) => {
        const range = this.olcsControl.getTiltRange();
        this.minTilt_ = range[0];
        this.maxTilt_ = range[1];
      }
    );

    const tiltRightEl = $('#tilt-right');
    const tiltLeftEl = $('#tilt-left');

    this.scope_.$watch(
      () => this.olcsControl.getHeading(),
      (value) => {
        this.rotateElement_($('#rotation3d'), value);
      },
      true
    );

    this.scope_.$watch(
      () => this.olcsControl.getTiltOnGlobe(),
      (value) => {
        this.rotateElement_($('#angle3d'), value);

        // if min or max tilt is reached, disable the tilting buttons
        const buffer = 0.01; // rad
        if (value - this.minTilt_ < buffer) {
          tiltRightEl.addClass('right-inactive');
        } else if (tiltRightEl.hasClass('right-inactive')) {
          tiltRightEl.removeClass('right-inactive');
        }
        if (this.maxTilt_ - value < buffer) {
          tiltLeftEl.addClass('left-inactive');
        } else if (tiltLeftEl.hasClass('left-inactive')) {
          tiltLeftEl.removeClass('left-inactive');
        }
      },
      true
    );

  }


  /**
   * @param {jQuery} element Element to rotate.
   * @param {(number|undefined)} angle Angle in radians
   * @private
   */
  rotateElement_(element, angle) {
    const r = `rotate(${angle}rad)`;
    element.css({
      '-moz-transform': r,
      '-webkit-transform': r,
      '-o-transform': r,
      '-ms-transform': r,
      'transform': r
    });
  }


  /**
   * @param {number} angle Angle in degrees.
   * @export
   */
  rotate(angle) {
    angle = Cesium.Math.toRadians(angle);
    this.olcsControl.setHeading(angle);
  }


  /**
   * @param {number} angle Angle in degrees.
   * @export
   */
  tilt(angle) {
    angle = Cesium.Math.toRadians(angle);
    const tiltOnGlobe = this.olcsControl.getTiltOnGlobe();
    if (tiltOnGlobe + angle < this.minTilt_) {
      angle = this.minTilt_ - tiltOnGlobe;
    } else if (tiltOnGlobe + angle > this.maxTilt_) {
      angle = this.maxTilt_ - tiltOnGlobe;
    }
    this.olcsControl.tiltOnGlobe(angle);
  }


  /**
   * @param {number} step Resolution offset. 1 to zoom out and -1 to zoom in.
   * @export
   */
  zoom(step) {
    const view = this.olcsControl.getOlView();
    const cur = view.getResolution();
    // compute the next resolution depending on the step
    const next = getConstrainedResolution(view, cur + step, step);
    view.setResolution(next);
  }
}


/**
 * @type {!angular.Component}
 */
const appControls3d = {
  bindings: {
    'olcsControl': '<appControls3dOlcs'
  },
  controller: Controls3dController,
  templateUrl: 'partials/controls3d.html'
};


appBase.component('appControls3d', appControls3d);


export default appControls3d;
